import React from "react";
import {
  useRoutes,
} from "react-router-dom";
import "./App.css";
import getRoutes from "./routes";
import { useSelector } from "react-redux";

function App() {
  const user = useSelector((state) => state.admins.user);
  const routing = useRoutes(getRoutes(user ? user : null));
  return <>{routing}</>;
}

export default App;
